const LISTE_LIGNE_COMMANDE_ACHAT = {
  title: 'Liste des lignes de commande',
  tabs: {
    codeDcf: 'N° Commande',
    produitLibelle: 'Produit d\'achat',
    dateDevisCommande: 'Date commande',
    listeIntervenants: 'Fourisseur(s)',
    etatDcf: 'Etat commande',
    totalHtAvecLigneRemise: 'Total HT ligne',
    quantite: 'Quantité',
    uniteVente: 'Unité',
    libelle: 'Libellé ligne',
  },
  filtre: {
    dateCommande: 'Date de commande',
    fournisseur: 'Fourisseur(s)',
    code: 'N° Commande',
    etat: 'Liste des états',
    referenceFournisseur: 'Référence fournisseur',
    agence: 'Agence(s)',
    libelleProduit: 'Libellé produit',
    produits: 'Produits',
  },
};

export default LISTE_LIGNE_COMMANDE_ACHAT;
